import DittoModel from './ditto-new'

export default class Video extends DittoModel {}
